import { useQuery } from '@tanstack/react-query';
import {
    getBasicProperty,
    getProperty, getPropertyContactList, getPropertyKeyPickupLocation,
} from '../service';

type UsePropertyOpts = {
    enabled?: boolean;
};

function useProperty(propertyId: string | number, opts: UsePropertyOpts = {}) {
    const query = useQuery({
        queryKey: ['property', propertyId],
        queryFn: () => getProperty(propertyId),
        ...opts,
    });

    return query;
}

function useBasicProperty(
    propertyId: string | number,
    opts: UsePropertyOpts = {}
) {
    const query = useQuery({
        queryKey: ['basic-property', propertyId],
        queryFn: () => getBasicProperty(propertyId),
        ...opts,
    });

    return query;
}

function usePropertyContactList(
    propertyId: number,
    params: {
        includeLandlords?: boolean;
        includePropertyManagers?: boolean;
        includeOccupants?: boolean;
    } = {},
    isEnabled = true
) {
    const query = useQuery({
        queryKey: ['property', propertyId, 'contacts', params],
        queryFn: () => getPropertyContactList(propertyId, params),
        enabled: isEnabled,
    });

    return query;
}

function usePropertyKeyPickupLocation(propertyId: string | number) {
    const query = useQuery({
        queryKey: ['property', propertyId, 'key-location'],
        queryFn: () => getPropertyKeyPickupLocation(propertyId),
    });

    return query;
}

export {
    useProperty,
    usePropertyContactList,
    usePropertyKeyPickupLocation,
    useBasicProperty,
};
